import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';

import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { TeamService } from 'src/providers/team/team';
import { Webhooks } from 'src/providers/webhooks/webhooks';

import { Loading } from 'src/shared/components/loading/loading';
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { WebhookAttemptPage } from '../webhook-attempt/webhook-attempt';

@Component({
    templateUrl: 'add-webhook.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class AddWebhookPage implements OnInit {

  channelItems: any;
  eventItems: any;
  errorMessage: string;
  form: UntypedFormGroup;
  isAccountAdmin: boolean;
  hasTeams: boolean;
  submitted: boolean;
  showSelectedEventsError: boolean;
  teamItems: any;
  loaded: boolean;
  isRightSideContent = true;
  dialogParams: any;

  
  boundAddWebhook = this.addWebhook.bind(this);

constructor(
    private fb: UntypedFormBuilder,
    private navCtrl: CustomNavController,
    private teamService: TeamService,
    private webhook: Webhooks,
    private storage: TidyStorage,
    private rightSidePanelService: RightSidePanelService,
  ) {
    this.form = this.fb.group({
      webhookUrl: ['', Validators.required],
      description: '',
      channel: ['', Validators.required],
      events: [''],
      team: ['']
    });
  }

  async ngOnInit() {
    try {
      this.isRightSideContent = await this.storage.retrieve('dialog-right-side-open') || false;
      this.rightSidePanelService.setDialogPageTitle('Add Webhook Endpoint');
      if (this.isRightSideContent) {
        this.dialogParams = await this.storage.retrieve('dialog-params');
      }
      this.errorMessage = '';
      this.loaded = false;
      this.channelItems = this.buildChannelItems();
      this.eventItems = await this.buildEventItems();
      const userRole = localStorage.getItem('user_role');
      this.isAccountAdmin = userRole !== 'member';
      if (this.isAccountAdmin) {
        this.form.controls.team.setValidators([Validators.required]);
        await this.getTeamItems();
        this.hasTeams = this.teamItems.length > 1;
      }
      this.loaded = true;
    } catch (err) {
      this.errorMessage = err.error ? err.error.message : err.message;
    }
  }

  async getTeamItems() {
    this.teamItems = [];
    const teams = await this.teamService.getTeams();
    teams.map((team) => {
      this.teamItems.push({
        viewValue: team.name,
        value: team.id
      });
    });
    this.teamItems.unshift({
      viewValue: 'All Groups',
      value: ''
    });
  }

  async buildEventItems() {
    const events = await this.webhook.getWebhookEvents();
    const array: any = [];
    events.map((event) => {
      array.push({
        value: event.key,
        viewValue: event.display_name,
        description: event.description,
        checked: false
      })
    });
    return array;
  }

  buildChannelItems() {
    return [
      {
        value: 'webhook',
        viewValue: 'Standard Webhook'
      },
      {
        value: 'slack',
        viewValue: 'Slack'
      }
    ];
  }

  @Loading('', true)
  async addWebhook() {
    this.errorMessage = '';
    this.submitted = true;
    const selectedEvents: any = [];
    this.eventItems.map((item) => {
      if (item.checked) {
        selectedEvents.push(item.value);
      }
    });
    if (!this.form.valid || selectedEvents.length === 0) {
      if (selectedEvents.length === 0) {
        this.showSelectedEventsError = true;
      }
      return;
    }
    try {
      const payload = {
        webhook_url: this.form.value.webhookUrl,
        description: this.form.value.description,
        channel: this.form.value.channel,
        events: selectedEvents
      }
      if (this.isAccountAdmin && this.form.value.team !== '') {
        payload['account_team_id'] = this.form.value.team
      }
      const response: any = await this.webhook.addWebhook(payload);
      this.runTestWebhook(response);
      await this.webhook.testWebhook(response.id);
    } catch (err) {
      this.errorMessage = err.error ? err.error.message : err.message;
    }
  }

  @Loading('', true)
  async runTestWebhook(webhook) {
    try {
      const testObject = await this.webhook.testWebhook(webhook.id);
      this.goToWebhookAttempt(webhook, testObject, 'succeeded')
    } catch ( err ) {
      this.goToWebhookAttempt(webhook, err, 'failed')
    }
  }

  goToWebhookAttempt(webhook, attemptObject, status) {
    const params = {
      webhook,
      customTitle: 'Webhook Added',
      request: attemptObject.request,
      response: attemptObject.response,
      errorReturned: attemptObject,
      nextPage: 'webhook-details',
      status
    };
    this.rightSidePanelService.navigateTo('webhook-attempt', params, WebhookAttemptPage);
  }

  goBack() {
    if (this.isRightSideContent) {
      this.rightSidePanelService.goBack();
    } else {
      this.navCtrl.back();
    }
  }
}
